import { Col, Row } from 'react-bootstrap';
import Main from '../components/Layout/Main';
import Sidebar from '../components/Layout/Sidebar';
import Ansprechpartner from '../components/Sidebar/Ansprechpartner';
import Kachel from '../components/kachel';

function Leistungen() {
  return (
    <div>
         <Row>
            <Col className="page-header">
                <h1>Unsere Leistungen</h1>
            </Col>
        </Row>
        <Row className='page-main'>
            <Main>
                <Row>
                    <Col xs={12} md={4} className='bg-red'>
                        <Kachel icon='/icon_vernetzung.svg'>
                            <li>Hol- und Bringservice</li>
                            <li>Hohe Teileverfügbarkeit<br /><small>durch Nachtanlieferung oder Sofortbeschaffung</small></li>
                            <li>Teilebeschaffung<br /><small>für sämtliche Fahrzeugfabrikate</small></li>
                        </Kachel>
                    </Col>
                    <Col xs={12} md={4} className='bg-white'>
                        <Kachel icon='/Leistungen.svg'>
                            <li>MAN-Servicepartner</li>
                            <li>Tägliche DEKRA-Abnahme</li>
                            <li>Abgasuntersuchungen<br /><small>für sämtliche Fahrzeuge</small></li>
                            <li>Fahrtenschreiber-Service<br /><small>nach §57b</small></li>
                        </Kachel>
                    </Col>
                    <Col xs={12} md={4} className='bg-red'>
                        <Kachel icon='/abschlepp.svg' bgColor={'anthrazite'}>
                            <li>Abschleppservice</li>
                            <li>Service für Ladebordwände, einschließlich UVV-Prüfung</li>
                            <li>Bremsendienst</li>
                        </Kachel>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} md={4} className='bg-white'>
                        <Kachel icon='/tools.svg'>
                            <li>Optische Achsenvermessung</li>
                            <li>Toll-Collect Partner</li>
                        </Kachel>
                    </Col>
                    <Col xs={12} md={4} className='bg-red'>
                        <Kachel icon='/wartung.svg' bgColor={"anthrazite"}>
                            <li>Karosserie- und Unfallinstandsetzung</li>
                            <li>Klima- und Standheizungsservice</li>
                        </Kachel>
                    </Col>
                    <Col xs={12} md={4} className='bg-white'>
                        <Kachel icon='/sicherheitspruefung.svg'>
                            <li>Sicherheitsprüfungen</li>
                            <li>Hydraulik-, Abroller-, Absetzer- und Kranarbeiten, einschließlich UVV-Prüfung</li>
                        </Kachel>
                    </Col>
                </Row>
            </Main>
            
            <Sidebar>
                <h2 className='text-center py-2 man-red'>Ihre Ansprech&shy;partner</h2>
                <Ansprechpartner name="Dirk Herper" position="Serviceberater & Managementbeauftrager" phone="+49 2421 9875 30" mail="info@heinrich-heiden.de" picture="/profil_dirk.jpeg" />
                <hr className='manHr' />
                <Ansprechpartner name="Thomas Maiwald" position="Werkstattleitung" phone="+49 2421 9875 20" mail="info@heinrich-heiden.de" />
            </Sidebar>
        </Row>
    </div>
  );
}

export default Leistungen;